import React from 'react';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const ButtonsGroup = (props) => {
  const { className = '', data, currentValue, onChange } = props;
  const { t } = useAutoTranslation();

  return (
    <div className={`btn-group ${className}`}>
      {data.map((b) => (
        <button
          key={b.value}
          type="button"
          className={`btn btn-xs ${currentValue === b.value ? `btn-secondary` : `btn-light`} ${
            b.disabled && b.disabledTooltip ? 'help-tooltip-wrapper' : ''
          }`}
          disabled={b.disabled}
          style={{ opacity: 1 }}
          onClick={() => onChange(b.value)}
        >
          {b.disabled ? <i className="fe-lock mr-1" /> : null}
          {t(b.label)}
          {b.disabled && b.disabledTooltip ? (
            <span className="help-tooltip">{b.disabledTooltip}</span>
          ) : null}
        </button>
      ))}
    </div>
  );
};

export default ButtonsGroup;
